import React from "react";

function SvgIcMapPoi059(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M15.963 20.81c.248.164.512.3.79.4l.21.07V26h-2v-4.72a3.75 3.75 0 001-.47zm5.598-.126c.13.1.264.18.402.231V24h-1v-2.935c.209-.113.406-.242.598-.38zm-11.077-.053c.115.096.235.174.357.232l.122.052V24h-1v-3.071c.18-.061.354-.158.52-.298zM16.106 6c1.496 0 2.765.96 3.233 2.296.065-.004.13-.01.196-.01a3.428 3.428 0 011.842 6.317 3.429 3.429 0 01-2.985 5.112 3.415 3.415 0 01-2.286-.878 3.413 3.413 0 01-2.286.878 3.429 3.429 0 01-3.054-4.981 3.428 3.428 0 012.097-6.412A3.43 3.43 0 0116.106 6zm8.534 3.869a2.749 2.749 0 012.323 2.714c0 .975-.508 1.828-1.271 2.316a2.75 2.75 0 01-2.6 4.091 5.38 5.38 0 00.615-3.803 5.397 5.397 0 001.256-3.473c0-.648-.114-1.268-.323-1.845zm-17.576.054a5.4 5.4 0 001.183 5.532A5.4 5.4 0 008.916 19l-.02.001a2.75 2.75 0 01-2.75-2.75c0-.449.11-.87.3-1.245a2.75 2.75 0 01.618-5.082z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi059;
